const analyticMap: { [key: string]: { component: string; colWidth: string; icon: string } } = {
    "10000": { component: "SectorsByFoundingYear", colWidth: "12", icon: "fa-chart-line" },
    "10001": { component: "OrgsFoundingYear", colWidth: "12", icon: "fas fa-chart-line" },
    "10002": { component: "SectorsByCountry", colWidth: "12", icon: "fas fa-chart-bar" },
    "10003": { component: "OwnershipType", colWidth: "6", icon: "fas fa-chart-pie" },
    "10004": { component: "InHouseManufacturing", colWidth: "6", icon: "fa-chart-pie" },
    "10005": { component: "InternalManufacturing", colWidth: "12", icon: "fa-chart-bar" },
    "10006": { component: "ProductDistributionLevel1", colWidth: "6", icon: "fa-chart-pie" },
    "10007": { component: "ServiceDistributionLevel1", colWidth: "6", icon: "fa-chart-pie" },
    "10008": { component: "ProductDistributionLevel2", colWidth: "12", icon: "fa-chart-bar" },
    "10009": { component: "ServiceDistributionLevel2", colWidth: "12", icon: "fa-chart-bar" },
};

export default analyticMap;
